import { FC } from "react";

export const UnknownMessage: FC = () => <></>;
